<template>
  <div class="account-contract--container">
    <div class="account-contract--fields">
      <div class="alert alert-sm alert-success">
        <p>
          После заполнения своих реквизитов, вы сможете выгружать АКТы за ваши платежи,
          начиная с даты заполнения этих самых данных.
        </p>
        <p>
          Будьте внимательны при заполнении! Данные нельзя будет изменить самостоятельно. Если сделали опечатку - обратитесь
          в раздел "Поддержка"
        </p>
        <p>
          <b>Если у вашей компании изменились реквизиты</b> (юридический адрес, КПП, наименование), то для внесения изменений
          потребуется предоставить скан-копию официального письма, в котором будут указаны:<br>
          - дата смены реквизитов;<br>
          - новые реквизиты организации;<br>
          - печать организации и подпись уполномоченного лица;<br>
          Письмо можно отправить на e-mail: info@enroller.ru
        </p>
        <p>
          <b>В случае реорганизации</b> будет необходимо предоставить скан-копии следующих документов:<br>
          - Официальное письмо о реорганизации.
          В письме должны быть указаны старые и новые реквизиты юридического лица, дата проведения реорганизации и
          информация о том, что новое юридическое лицо является правопреемником прежнего юридического лица.<br>
          - Выписку из ЕГРЮЛ на новое юридическое лицо.
          В выписке должно быть отражено, что новое юридическое лицо образовано в результате реорганизации прежнего
          юридического лица.<br>
          Документы можно отправить на e-mail: info@enroller.ru
        </p>
      </div>
      <div class="shadow-card mrg-t-15">

        <div class="input-block">
          <label for="type">Тип аккаунта <span class="req">*</span></label>
          <select :disabled="canEdit == 0" v-model="data.type" id="type">
            <option value="legal">Юридическое лицо</option>
            <option value="ip">Индивидуальный предприниматель</option>
          </select>
          <div class="form-error"></div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="organization_name">Наименование организации <span class="req">*</span></label>
          <input
              @focus="formError.organization_name = ''"
              @blur="v_organization_name"
              type="text"
              v-model="data.organization_name"
              id="organization_name"
              :disabled="canEdit == 0"
          />
          <div class="hint">Например: ООО "Моя компания"</div>
          <div class="form-error">{{formError.organization_name}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'ip'">
          <label for="ip_name">Наименование ИП <span class="req">*</span></label>
          <input
              @focus="formError.ip_name = ''"
              @blur="v_ip_name"
              type="text"
              v-model="data.ip_name"
              id="ip_name"
              :disabled="canEdit == 0"
          />
          <div class="hint">Например: ИП Морозов Павел Сергеевич</div>
          <div class="form-error">{{formError.ip_name}}</div>
        </div>

        <div class="input-block">
          <label for="legal_address">Юридический адрес <span class="req">*</span></label>
          <input
              @focus="formError.legal_address = ''"
              @blur="v_legal_address"
              type="text"
              v-model="data.legal_address"
              id="legal_address"
              :disabled="canEdit == 0"
          />
          <div class="hint">Полный. Например: г.Москва, ул. Ленина, д.1 ...</div>
          <div class="form-error">{{formError.legal_address}}</div>
        </div>

        <div class="input-block">
          <label for="inn">ИНН <span class="req">*</span></label>
          <input
              @focus="formError.inn = ''"
              @blur="v_inn"
              type="text"
              v-model="data.inn"
              id="inn"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.inn}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="kpp">КПП <span class="req">*</span></label>
          <input
              @focus="formError.kpp = ''"
              @blur="v_kpp"
              type="text"
              v-model="data.kpp"
              id="kpp"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.kpp}}</div>
        </div>

        <div class="input-block">
          <label for="ogrn_ogrnip">ОГРН / ОГРНИП <span class="req">*</span></label>
          <input
              @focus="formError.ogrn_ogrnip = ''"
              @blur="v_ogrn_ogrnip"
              type="text"
              v-model="data.ogrn_ogrnip"
              id="ogrn_ogrnip"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.ogrn_ogrnip}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="fio_contract_person">ФИО лица заключающего договор <span class="req">*</span></label>
          <input
              @focus="formError.fio_contract_person = ''"
              @blur="v_fio_contract_person"
              type="text"
              v-model="data.fio_contract_person"
              id="fio_contract_person"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.fio_contract_person}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="profession_contract_person">Должность лица заключающего договор <span class="req">*</span></label>
          <input
              @focus="formError.profession_contract_person = ''"
              @blur="v_profession_contract_person"
              type="text"
              v-model="data.profession_contract_person"
              id="profession_contract_person"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.profession_contract_person}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="organization_phone">Номер телефона организации <span class="req">*</span></label>
          <input
              @focus="formError.organization_phone = ''"
              @blur="v_organization_phone"
              type="text"
              v-model="data.organization_phone"
              id="organization_phone"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.organization_phone}}</div>
        </div>

        <div class="input-block">
          <label for="post_index">Почтовый индекс <span class="req">*</span></label>
          <input
              @focus="formError.post_index = ''"
              @blur="v_post_index"
              type="text"
              v-model="data.post_index"
              id="post_index"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.post_index}}</div>
        </div>

        <div class="input-block">
          <label for="post_address">Почтовый адрес <span class="req">*</span></label>
          <input
              @focus="formError.post_address = ''"
              @blur="v_post_address"
              type="text"
              v-model="data.post_address"
              id="post_address"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.post_address}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="bookkeeper_email">E-mail бухгалтера <span class="req">*</span></label>
          <input
              @focus="formError.bookkeeper_email = ''"
              @blur="v_bookkeeper_email"
              type="text"
              v-model="data.bookkeeper_email"
              id="bookkeeper_email"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.bookkeeper_email}}</div>
        </div>

        <div class="input-block">
          <label for="payment_account_bank">Расчетный счет банка <span class="req">*</span></label>
          <input
              @focus="formError.payment_account_bank = ''"
              @blur="v_payment_account_bank"
              type="text"
              v-model="data.payment_account_bank"
              id="payment_account_bank"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.payment_account_bank}}</div>
        </div>

        <div class="input-block">
          <label for="payment_name_bank">Наименование банка <span class="req">*</span></label>
          <input
              @focus="formError.payment_name_bank = ''"
              @blur="v_payment_name_bank"
              type="text"
              v-model="data.payment_name_bank"
              id="payment_name_bank"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.payment_name_bank}}</div>
        </div>

        <div class="input-block">
          <label for="payment_correspondent_account">Корреспондентский счет <span class="req">*</span></label>
          <input
              @focus="formError.payment_correspondent_account = ''"
              @blur="v_payment_correspondent_account"
              type="text"
              v-model="data.payment_correspondent_account"
              id="payment_correspondent_account"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.payment_correspondent_account}}</div>
        </div>

        <div class="input-block">
          <label for="payment_bik_bank">БИК банка <span class="req">*</span></label>
          <input
              @focus="formError.payment_bik_bank = ''"
              @blur="v_payment_bik_bank"
              type="text"
              v-model="data.payment_bik_bank"
              id="payment_bik_bank"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.payment_bik_bank}}</div>
        </div>

        <div class="input-block" v-if="data.type == 'legal'">
          <label for="fio_contact_person">ФИО контактного лица <span class="req">*</span></label>
          <input
              @focus="formError.fio_contact_person = ''"
              @blur="v_fio_contact_person"
              type="text"
              v-model="data.fio_contact_person"
              id="fio_contact_person"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.fio_contact_person}}</div>
        </div>

        <div class="input-block">
          <label for="phone_number_contact_person">
            <span v-if="data.type == 'legal'">Номер телефона контактного лица</span>
            <span v-if="data.type == 'ip'">Контактный номер телефона</span>
            <span class="req"> *</span>
          </label>
          <input
              @focus="formError.phone_number_contact_person = ''"
              @blur="v_phone_number_contact_person"
              type="text"
              v-model="data.phone_number_contact_person"
              id="phone_number_contact_person"
              :disabled="canEdit == 0"
          />
          <div class="form-error">{{formError.phone_number_contact_person}}</div>
        </div>

        <div class="text-success mrg-t-10" v-if="canEdit == 0 && data.id != '' && data.datetime != ''">
          <p>
            #{{data.id}} от {{data.datetime}}
          </p>
        </div>

        <div v-if="canEdit == 1" class="input-block">
          <div @click="showSavePopup" class="btn btn-sm btn-success">Сохранить</div>
        </div>

      </div>
    </div>

    <popup
        :closeButton="savePopup.closeButton"
        :actionButton="savePopup.actionButton"
        :actionClass="savePopup.actionClass"
        :show="savePopup.show"
        :size="savePopup.size"
        @closePopup="closeSavePopup"
        @actionPopup="actionSavePopup"
    >
      <div slot="header">Согласие с пользовательским соглашением</div>
      <div slot="body">
        Пожалуйста, ознакомьтесь с пользовательским соглашением
        <div class="licence mrg-t-10">
          <a href="https://enroller.ru/user-agreement.html" target="_blank" class="cursor-pointer">
            Пользовательское соглашение (нажать для просмотра)
          </a>
        </div>
        <div class="input-block">
          <label>
            <input type="checkbox" id="reg-licence" v-model="iAgree" />
            Я ознакомился с пользовательским соглашением и принимаю его условия
          </label>
        </div>
      </div>
    </popup>

  </div>
</template>

<script>

import Validator from "../../libraries/Validator";
import Popup from "../../Popup";
import userRepository from "../../../repositories/user";

const validator = new Validator();

export default {
  name: "AccountContract",
  components: {Popup },
  data() {
    return {
      savePopup: {
        show: false,
        actionButton: 'Продолжить',
        actionClass: 'btn-success',
        size: "lg"
      },
      canEdit: 0,
      iAgree: false,
      data: {
        id: '',
        type: 'legal',
        organization_name: '',
        inn: '',
        legal_address: '',
        kpp: '',
        ogrn_ogrnip: '',
        fio_contract_person: '',
        profession_contract_person: '',
        organization_phone: '',
        post_index: '',
        post_address: '',
        bookkeeper_email: '',
        payment_account_bank: '',
        payment_name_bank: '',
        payment_correspondent_account: '',
        payment_bik_bank: '',
        fio_contact_person: '',
        phone_number_contact_person: '',
        ip_name: '',
        datetime: ''
      },
      formError: {
        organization_name: '',
        inn: '',
        legal_address: '',
        kpp: '',
        ogrn_ogrnip: '',
        fio_contract_person: '',
        profession_contract_person: '',
        organization_phone: '',
        post_index: '',
        post_address: '',
        bookkeeper_email: '',
        payment_account_bank: '',
        payment_name_bank: '',
        payment_correspondent_account: '',
        payment_bik_bank: '',
        fio_contact_person: '',
        phone_number_contact_person: '',
        ip_name: ''
      }
    };
  },
  props: {

  },
  watch: {},
  computed: {
    validateLegal() {
      let errorCount = 0;
      this.v_organization_name().result == "error" ? errorCount++ : "";
      this.v_legal_address().result == "error" ? errorCount++ : "";
      this.v_inn().result == "error" ? errorCount++ : "";
      this.v_kpp().result == "error" ? errorCount++ : "";
      this.v_ogrn_ogrnip().result == "error" ? errorCount++ : "";
      this.v_fio_contract_person().result == "error" ? errorCount++ : "";
      this.v_profession_contract_person().result == "error" ? errorCount++ : "";
      this.v_organization_phone().result == "error" ? errorCount++ : "";
      this.v_post_index().result == "error" ? errorCount++ : "";
      this.v_post_address().result == "error" ? errorCount++ : "";
      this.v_bookkeeper_email().result == "error" ? errorCount++ : "";
      this.v_payment_account_bank().result == "error" ? errorCount++ : "";
      this.v_payment_name_bank().result == "error" ? errorCount++ : "";
      this.v_payment_correspondent_account().result == "error" ? errorCount++ : "";
      this.v_payment_bik_bank().result == "error" ? errorCount++ : "";
      this.v_fio_contact_person().result == "error" ? errorCount++ : "";
      this.v_phone_number_contact_person().result == "error" ? errorCount++ : "";

      return errorCount;
    },
    validateIp() {
      let errorCount = 0;
      this.v_ip_name().result == "error" ? errorCount++ : "";
      this.v_legal_address().result == "error" ? errorCount++ : "";
      this.v_inn().result == "error" ? errorCount++ : "";
      this.v_ogrn_ogrnip().result == "error" ? errorCount++ : "";
      this.v_post_index().result == "error" ? errorCount++ : "";
      this.v_post_address().result == "error" ? errorCount++ : "";
      this.v_payment_account_bank().result == "error" ? errorCount++ : "";
      this.v_payment_name_bank().result == "error" ? errorCount++ : "";
      this.v_payment_correspondent_account().result == "error" ? errorCount++ : "";
      this.v_payment_bik_bank().result == "error" ? errorCount++ : "";
      this.v_phone_number_contact_person().result == "error" ? errorCount++ : "";

      return errorCount;
    },
  },
  methods: {
    closeSavePopup(){
      this.savePopup.show = false;
    },
    showSavePopup(){
      this.savePopup.show = true;
    },
    actionSavePopup(){
      if(!this.iAgree){
        this.$store.dispatch("addNotification", {
          text: 'Вы не приняли условия пользовательского соглашения',
          time: 6,
          color: "danger"
        });
        return false;
      }
      this.closeSavePopup();
      this.setData();
    },
    v_organization_name(){
      let validate = validator.validate([
        {
          fieldName: "Наименование организации",
          value: this.data.organization_name,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.organization_name = validate.message)
          : (this.formError.organization_name = "");
      return validate;
    },
    v_ip_name(){
      let validate = validator.validate([
        {
          fieldName: "Наименование ИП",
          value: this.data.ip_name,
          type: "required",
          length: 150
        }
      ]);
      validate.result == "error"
          ? (this.formError.ip_name = validate.message)
          : (this.formError.ip_name = "");
      return validate;
    },
    v_legal_address(){
      let validate = validator.validate([
        {
          fieldName: "Юридический адрес",
          value: this.data.legal_address,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.legal_address = validate.message)
          : (this.formError.legal_address = "");
      return validate;
    },
    v_inn(){
      let validate = validator.validate([
        {
          fieldName: "ИНН",
          value: this.data.inn,
          type: "required",
          length: 25
        }
      ]);
      validate.result == "error"
          ? (this.formError.inn = validate.message)
          : (this.formError.inn = "");
      return validate;
    },
    v_kpp(){
      let validate = validator.validate([
        {
          fieldName: "КПП",
          value: this.data.kpp,
          type: "required",
          length: 25
        }
      ]);
      validate.result == "error"
          ? (this.formError.kpp = validate.message)
          : (this.formError.kpp = "");
      return validate;
    },
    v_ogrn_ogrnip(){
      let validate = validator.validate([
        {
          fieldName: "ОГРН / ОГРНИП",
          value: this.data.ogrn_ogrnip,
          type: "required",
          length: 35
        }
      ]);
      validate.result == "error"
          ? (this.formError.ogrn_ogrnip = validate.message)
          : (this.formError.ogrn_ogrnip = "");
      return validate;
    },
    v_fio_contract_person(){
      let validate = validator.validate([
        {
          fieldName: "ФИО лица заключающего договор",
          value: this.data.fio_contract_person,
          type: "required",
          length: 200
        }
      ]);
      validate.result == "error"
          ? (this.formError.fio_contract_person = validate.message)
          : (this.formError.fio_contract_person = "");
      return validate;
    },
    v_profession_contract_person(){
      let validate = validator.validate([
        {
          fieldName: "Должность лица заключающего договор",
          value: this.data.profession_contract_person,
          type: "required",
          length: 200
        }
      ]);
      validate.result == "error"
          ? (this.formError.profession_contract_person = validate.message)
          : (this.formError.profession_contract_person = "");
      return validate;
    },
    v_organization_phone(){
      let validate = validator.validate([
        {
          fieldName: "Номер телефона организации",
          value: this.data.organization_phone,
          type: "required",
          length: 20
        }
      ]);
      validate.result == "error"
          ? (this.formError.organization_phone = validate.message)
          : (this.formError.organization_phone = "");
      return validate;
    },
    v_post_index(){
      let validate = validator.validate([
        {
          fieldName: "Почтовый индекс",
          value: this.data.post_index,
          type: "required",
          length: 20
        }
      ]);
      validate.result == "error"
          ? (this.formError.post_index = validate.message)
          : (this.formError.post_index = "");
      return validate;
    },
    v_post_address(){
      let validate = validator.validate([
        {
          fieldName: "Почтовый адрес",
          value: this.data.post_address,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.post_address = validate.message)
          : (this.formError.post_address = "");
      return validate;
    },
    v_bookkeeper_email(){
      let validate = validator.validate([
        {
          fieldName: "E-mail бухгалтера",
          value: this.data.bookkeeper_email,
          type: "required",
          length: 250
        },
        {
          fieldName: "E-mail бухгалтера",
          value: this.data.bookkeeper_email,
          type: "email",
          length: 250
        },
      ]);
      validate.result == "error"
          ? (this.formError.bookkeeper_email = validate.message)
          : (this.formError.bookkeeper_email = "");
      return validate;
    },
    v_payment_account_bank(){
      let validate = validator.validate([
        {
          fieldName: "Расчетный счет банка",
          value: this.data.payment_account_bank,
          type: "required",
          length: 35
        }
      ]);
      validate.result == "error"
          ? (this.formError.payment_account_bank = validate.message)
          : (this.formError.payment_account_bank = "");
      return validate;
    },
    v_payment_name_bank(){
      let validate = validator.validate([
        {
          fieldName: "Наименование банка",
          value: this.data.payment_name_bank,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.payment_name_bank = validate.message)
          : (this.formError.payment_name_bank = "");
      return validate;
    },
    v_payment_correspondent_account(){
      let validate = validator.validate([
        {
          fieldName: "Корреспондентский счет",
          value: this.data.payment_correspondent_account,
          type: "required",
          length: 200
        }
      ]);
      validate.result == "error"
          ? (this.formError.payment_correspondent_account = validate.message)
          : (this.formError.payment_correspondent_account = "");
      return validate;
    },
    v_payment_bik_bank(){
      let validate = validator.validate([
        {
          fieldName: "БИК банка",
          value: this.data.payment_bik_bank,
          type: "required",
          length: 35
        }
      ]);
      validate.result == "error"
          ? (this.formError.payment_bik_bank = validate.message)
          : (this.formError.payment_bik_bank = "");
      return validate;
    },
    v_fio_contact_person(){
      let validate = validator.validate([
        {
          fieldName: "ФИО контактного лица",
          value: this.data.fio_contact_person,
          type: "required",
          length: 150
        }
      ]);
      validate.result == "error"
          ? (this.formError.fio_contact_person = validate.message)
          : (this.formError.fio_contact_person = "");
      return validate;
    },
    v_phone_number_contact_person(){
      let validate = validator.validate([
        {
          fieldName: "Номер телефона контактного лица",
          value: this.data.phone_number_contact_person,
          type: "required",
          length: 20
        }
      ]);
      validate.result == "error"
          ? (this.formError.phone_number_contact_person = validate.message)
          : (this.formError.phone_number_contact_person = "");
      return validate;
    },
    getData(){
      userRepository.getContract().then(resp => {
        this.setParams(resp.data.data);
        this.canEdit = resp.data.can_edit;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    setData(){
      if(this.data.type == 'legal'){
        if(this.validateLegal){
          return false;
        }
      }else if(this.data.type == 'ip'){
        if(this.validateIp){
          return false;
        }
      }

      const data = {};
      for(let key in this.data){
        data[key] = this.data[key];
      }
      userRepository.setContract(data).then(resp => {
        this.$store.dispatch("addNotification", {
          text: 'Сохранено',
          time: 3,
          color: "success"
        });
        this.setParams(resp.data.data);
        this.canEdit = resp.data.can_edit;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    setParams(params){
      for(let key in params){
        for(let keyD in this.data){
          if(key == keyD){
            this.data[keyD] = params[key];
          }
        }
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped lang="less">
.account-contract--container{
  width: 50%;
}
.licence {
  margin-bottom: 30px;
  color: red;
  font-weight: 700;
  text-decoration: underline;
}
@media (max-width: 1400px) {
  .account-contract--container{
    width: 100%;
  }
}
</style>
